import React from "react";
import ReactTooltip from "react-tooltip";

export function InfoTooltip({ id, text, position = "top", sticky = true }) {
  return (
    <>
      <img
        data-tip
        data-for={id}
        src={require("../assets/images/ico-info.png")}
        alt=""
        style={{ width: "12px" }}
      />
      <ReactTooltip
        id={id}
        type="dark"
        effect={sticky ? "solid" : ""}
        backgroundColor="#5B5B5B"
        className="tooltip-wrapper"
      >
        <span style={{ fontSize: "12px" }}>{text}</span>
      </ReactTooltip>
    </>
  );
}
